// Runtime configuration, fetched from `/config.json` at boot.
//
// The bundle is environment-agnostic: the same S3 objects serve dev and prod,
// and the deploy writes `config.json` beside them. Nothing here is a secret —
// the pas-auth issuer and domain, a public client id and an API base URL.

export interface RuntimeConfig {
  api_base_url: string
  /** The shared pas-auth Cognito sign-in (infra `cfg.auth`, from the pas-auth stack outputs). */
  auth: {
    /** The pool's issuer, `https://cognito-idp.us-east-1.amazonaws.com/<user-pool-id>`. */
    authority: string
    /** The pas-auth host for `/oauth2/authorize`, `/oauth2/token` and `/logout`, e.g. `auth.pas-dev.com`. */
    auth_domain: string
    /** This app's public client id (the pas-auth output `ClientIdHearingAid`). */
    client_id: string
    /** The one sign-in method the pas-auth client allows (output `SignInHearingAid`). */
    identity_provider: 'Entra' | 'COGNITO'
  }
  environment?: string
  version?: string
}

let cached: RuntimeConfig | null = null

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached
  const res = await fetch('/config.json', { cache: 'no-store' })
  if (!res.ok) throw new Error(`Could not load /config.json (HTTP ${res.status})`)
  cached = (await res.json()) as RuntimeConfig
  return cached
}

/** Set directly by the local harness, which has no deploy to write the file. */
export function setConfig(config: RuntimeConfig): void {
  cached = config
}

export function currentConfig(): RuntimeConfig {
  if (!cached) throw new Error('Runtime configuration has not been loaded yet.')
  return cached
}
